import script from "./number-box-field.vue?vue&type=script&setup=true&lang=ts"
export * from "./number-box-field.vue?vue&type=script&setup=true&lang=ts"

import "./number-box-field.vue?vue&type=style&index=0&id=4691f620&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4691f620"]])

export default __exports__